const pastJob = {
    name: '',
    formattedDate: null,
    formattedEndDate: null,
    type: '',
    showDatePicker: false,
    description: '',
    date: null,
    endDate: null
}

export default pastJob
